import React from 'react';
import './small-container.css';
import facesPartial from '../../assets/faces-partial.png';
import Logos from '../../logos/logos';

function SmallContainer({ children }) {
  return (
    <div className="faces-main-center-wrapper">
      <Logos />
      <div className="page-wrapper faces-content-center">
        <div className="faces-container">
          <img
            src={facesPartial}
            alt="FACES™ Software"
            className="faces-full-logo"
          />
          {children}
        </div>
      </div>
    </div>
  );
}

export default SmallContainer;
